import React from "react";
import { Card, CardBody, Container, Row,FormGroup,Input,Form ,Col} from "reactstrap";
import NkHeader from './../../../../common/nkheader';
import Loading from "../../../../pages/loader/loader"
import {getCreateReferrerCode} from "../../../../pages/settings/manageuserVerification/utils"

const CreateNewCodeheader = ( {
    code,    
    username, 
    loader,   
    handleCode,    
    handleUsername,
    handleSubmit,
    searchByValuePlaceholder,
    getCreateReferrerCode
}) => {

  // useEffect(() => {
  //   if (filterForm) {
  //     getReferrerCodes(filterForm);
  //   }
  // }, [filterForm]);
  

  // const getReferrerCodes = (request) => {
  //   
  //   request.size = sizeShow || 10;
  //   setDataLoading(true);
  //   getCreateReferrerCode(request)
  //     .then((res) => {
  //    
  //       setDataLoading(false);
  //       if (res && res.data && res.data.length > 0) {
  //         setReferrerCodeList(() => res.data);
  //       } else {
  //         setReferrerCodeList([]);
  //       }
  //       setPagination({
  //         ...pagination,
  //         pageSize: sizeShow || 10,
  //         total: res.data.totalCount,
  //         current: request.page,
  //       });
  //     })
  //     .catch((err) => {
  //       setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
  //       setDataLoading(false);
  //       setReferrerCodeList(Referrercodedata); //mockdata:getReferrerCodedata
  //     });
  // };

  return (
    <>
      <Container fluid>
        <NkHeader title="Create New Code" />   
        <Card>
          <CardBody>
            <Row>
              <Col lg="4" className="form-input-padding">
                <Form onSubmit={handleSubmit}>
                 
                    <label
                      className="form-control-label"
                      htmlFor="example3cols2Input"
                    >
                      Name:
                    </label>
                    <Input
                      id="example3cols2Input"
                      placeholder={searchByValuePlaceholder}
                      type="text"
                      name="username"
                      value={username}
                      onChange={handleUsername}
                    />
                  
                 
                    <label
                      className="form-control-label"
                      htmlFor="example3cols2Input"
                    >
                      Code:
                    </label>
                    <Input
                      id="example3cols2Input"
                      placeholder={searchByValuePlaceholder}
                      type="text"
                      name="code"
                      value={code}
                      onChange={handleCode}
                      maxlength="6"
                    />
                  
                 
                  <button
                    className="btn btn-primary mt-2"
                    type="submit"
                    
                    disabled={!code || !username }
                  >
                  {loader? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Create"
          )}
                  </button>
                </Form>
              </Col>
            </Row>
          </CardBody>
        </Card>
        
      </Container>
     
    </>
  );
};

export default CreateNewCodeheader;
